import { normalizeRomanianLocaleMap } from "@/lib/i18n-normalize"

export const confirmDialogTranslations = normalizeRomanianLocaleMap({
    ro: {
        confirmText: "Confirma",
        cancelText: "Anuleaza",
        deleteText: "Sterge",
        defaultTitle: "Confirmare actiune",
        defaultDescription: "Esti sigur ca vrei sa continui? Aceasta actiune nu poate fi anulata.",
    },
    en: {
        confirmText: "Confirm",
        cancelText: "Cancel",
        deleteText: "Delete",
        defaultTitle: "Confirm action",
        defaultDescription: "Are you sure you want to continue? This action cannot be undone.",
    },
    de: {
        confirmText: "Bestätigen",
        cancelText: "Abbrechen",
        deleteText: "Löschen",
        defaultTitle: "Aktion bestätigen",
        defaultDescription: "Sind Sie sicher, dass Sie fortfahren möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
    },
})
